export const queryKeys = {
  LESSONS_LIST: 'lessons-list',
  LESSONS_DETAIL: 'lessons-detail',
  LESSONS_TEST: 'lessons-test',
  LESSONS_RESULT: 'lessons-result'
};

export enum LessonStatus {
  UNSEEN = 'unseen',
  SEEN = 'seen',
  RESOLVED = 'resolved',
  REJECTED = 'rejected'
}
